import React, { Component } from 'react'
import { Link } from 'react-router'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'

import brower from 'src/helper/brower'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'

import lang from './lang'
// import { VochatToFalla } from 'src/helper/domain'
import { getlangV2, setlang } from 'src/helper/getlang'
import localstorage from 'src/helper/localstorage'
import { observable, action, autorun, computed, toJS } from 'mobx'
import score from 'src/helper/score'

import Reminder from './Reminder/index'
import Available from './Available/index'
import Treasures from './Treasures/index'
import Rank from './Rank/index'
import Reward from './Reward/index'
import Countdown from './Countdown'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    // 获取页面数据
    this.nationalStore = this.props.store.register('activity/national')
  }
  state = {
    show: 'none',
    selectState: '0',
    availShow: '-200vh',
    selectStateChild: '1',
    lang: langM.ar,
    rewardList: [],
    language:'en',
  }
  componentDidMount() {
    setDocumentTitle('National Star')
    if (this.state.language == 'tr') {
      setDocumentTitle('Ulusal Yıldız')
    }
    this.$logEvent('nationalStar_main_screen')
  }
  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    // 身份验证请求数据
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  //初始化
  RunOnStart = async (uid) => {
    this.setState({ uid: uid })
    await this.nationalStore.GetUserInfoWeb(uid)
    let res = await this.nationalStore.getRewardList()
    this.setState({
      rewardList: res
    })
    this.initNationalStoreData()
  }

  initNationalStoreData() {
    // 活动礼物
    this.nationalStore.GetGifts('this')
    // 国家金币总计
    this.nationalStore.GetGemstone('last')
    // 用户周排行
    this.nationalStore.GetUserRank('this')
    // 国家金币周排行
    this.nationalStore.GetGold('this')
    // 倒计时
    this.nationalStore.GetServerTime()
  }

  // component
  nationalAvatarList = (nationalListImg) => {
    return (
      <div className="nation-item">
        <div className="ava-list1">
          {nationalListImg.map((item, index) => {
            if (index < 8) {
              return <img src={item.img} alt="" />
            }
          })}
        </div>
        <div className="ava-list2">
          {nationalListImg
            .filter((ele, index) => {
              return index >= 8 && index <= 16
            })
            .map((item, index) => {
              return <img src={item.img} alt="" />
            })}
        </div>
      </div>
    )
  }
  reminderBtn = () => {
    return (
      <div className="avail-btn" onClick={() => this.changeAvail('0')}>
        {this.state.lang.ac}
      </div>
    )
  }
  serviceComp = () => {
    return (
      <div className="service" onClick={jumpToUser.bind(this, 977239)}>
        {this.state.lang.service}
      </div>
    )
  }
  copyrightComp = () => {
    return <div className="copyright">{this.state.lang.copyRight}</div>
  }

  // handle
  changeShow(bool) {
    this.setState({
      show: (this.state.show = bool)
    })
  }
  changeSelectState(val) {
    if (val == 0) {
      this.$logEvent('nationalStar_treasures')
    }
    if (val == 2) {
      this.$logEvent('nationalStar_reward')
    }
    this.setState({
      selectState: (this.state.selectState = val)
    })
  }
  changeAvail(val) {
    this.setState({
      availShow: (this.state.availShow = val)
    })
  }
  changeSelectStateChild(val) {
    if (val == 1) {
      this.$logEvent('nationalStar_thisweek_rank')
    }
    if (val == 2) {
      this.$logEvent('nationalStar_lastweek_rank')
    }
    this.setState({
      selectStateChild: (this.state.selectStateChild = val)
    })
  }
  changeTwo() {
    this.changeSelectState('1')
    this.changeSelectStateChild('1')
  }

  langHeaderBg() {
    switch (this.state.language) {
      case 'tr':
        return '/img/activity/national/head_tr.png'
      case 'ar':
        return '/img/activity/national/head_ar.png'
      default:
        return '/img/activity/national/head.png'
    }
  }

  render() {
    let { language, lang } = this.state
    let {
      userInfo,
      nationalList,
      rank,
      gifts,
      gemstone,
      thisGoldRank,
      gold,
      lastUserRank,
      myRank,
      remaintime,
      now,
      thisMyUserRank,
      lastMyUserRank
    } = this.nationalStore.data
  
    let nationalListImg = [
      {
        name: 'India',
        img: 'https://img.chatie.live/app/country/India.png',
        id: 43
      },
      {
        name: 'Iraq',
        img: 'https://img.chatie.live/app/country/Iraq.png',
        id: 32
      },
      {
        name: 'Pakistan',
        img: 'https://img.chatie.live/app/country/Pakistan.png',
        id: 10
      },
      {
        name: 'KSA',
        img: 'https://img.chatie.live/app/country/SaudiArabia.png',
        id: 17
      },
      {
        name: 'Turkey',
        img: 'https://img.chatie.live/app/country/Turkey.png',
        id: 39
      },
      {
        name: 'Algeria',
        img: 'https://img.chatie.live/app/country/Algeria.png',
        id: 40
      },
      {
        name: 'Oman',
        img: 'https://img.chatie.live/app/country/Oman.png',
        id: 9
      },
      {
        name: 'Yemen',
        img: 'https://img.chatie.live/app/country/Yemen.png',
        id: 15
      },
      {
        name: 'Kurdistan',
        img: 'https://img.chatie.live/app/country/Kurdistan.png',
        id: 46
      },
      {
        name: 'Bahrain',
        img: 'https://img.chatie.live/app/country/Bahrain.png',
        id: 3
      },
      {
        name: 'Egypt',
        img: 'https://img.chatie.live/app/country/Egypt.png',
        id: 42
      },
      {
        name: 'Jordan',
        img: 'https://img.chatie.live/app/country/Jordan.png',
        id: 30
      },
      {
        name: 'Kuwait',
        img: 'https://img.chatie.live/app/country/Kuwait.png',
        id: 25
      },
      {
        name: 'Lebanon',
        img: 'https://img.chatie.live/app/country/Lebanon.png',
        id: 28
      },
      {
        name: 'Morocco',
        img: 'https://img.chatie.live/app/country/Morocco.png',
        id: 34
      },
      {
        name: 'Palestine',
        img: 'https://img.chatie.live/app/country/Palestine.png',
        id: 27
      },
      {
        name: 'Qatar',
        img: 'https://img.chatie.live/app/country/Qatar.png',
        id: 16
      },
      {
        name: 'Syria',
        img: 'https://img.chatie.live/app/country/Syria.png',
        id: 33
      },
      {
        name: 'Tunisia',
        img: 'https://img.chatie.live/app/country/Tunisia.png',
        id: 18
      },
      {
        name: 'Uae',
        img: 'https://img.chatie.live/app/country/UnitedArabEmirates.png',
        id: 37
      }
    ]

    return (
      <div className="container">
        {/* 有效国家按钮 */}
        {this.reminderBtn()}

        {/* 规则按钮 */}
        {/* <div className="rule-btn" onClick={() => this.changeShow('block')}></div> */}

        {/* Banner */}
        <div className="header" style={{ backgroundImage: `url(${this.langHeaderBg()})` }}>
          {/* 国家头像列表 */}
          {this.nationalAvatarList(nationalListImg)}
        </div>

        {/* 上周国家之星 */}
        {gold && gold.length > 0 && (
          <div className="last-week">
            <div className="title">{lang.lw}</div>
            {gold && gold.length > 0 && (
              <div className="national-rank-wrap">
                {gold && gold.length > 0 && (
                  // No1
                  <div className="no1-box">
                    <div className="no1-wrap">
                      <div className="no1-bg-re">
                        <div className="pic">
                          <img src={gold[0].country_icon} alt="" />
                        </div>
                        <div className="bg"></div>
                      </div>
                    </div>
                    <div className="no1-info">
                      <div className="name">{gold[0].country_name}</div>
                      <div className="mon">
                        <span>{score(gold[0].gold)}</span>
                        <img src="/img/activity/national/jb.png" alt="" />
                      </div>
                    </div>
                  </div>
                )}
                <div className="no23-wrap">
                  {gold && gold.length > 1 && (
                    // No2
                    <div className="no1-box">
                      <div className="no1-wrap">
                        <div className="no2-bg-re">
                          <div className="pic">
                            {/* <img src="/img/activity/national/head.png" alt="" /> */}
                            <img src={gold[1].country_icon} alt="" />
                          </div>
                          <div className="bg"></div>
                        </div>
                      </div>
                      <div className="no1-info">
                        <div className="name">{gold[1].country_name}</div>
                        <div className="mon">
                          <span>{score(gold[1].gold)}</span>
                          <img src="/img/activity/national/jb.png" alt="" />
                        </div>
                      </div>
                    </div>
                  )}
                  {gold && gold.length > 2 && (
                    // No3
                    <div className="no1-box">
                      <div className="no1-wrap">
                        <div className="no3-bg-re">
                          <div className="pic">
                            {/* <img src="/img/activity/national/head.png" alt="" /> */}
                            <img src={gold[2].country_icon} alt="" />
                          </div>
                          <div className="bg"></div>
                        </div>
                      </div>
                      <div className="no1-info n">
                        <div className="name">{gold[2].country_name}</div>
                        <div className="mon">
                          <span>{score(gold[2].gold)}</span>
                          <img src="/img/activity/national/jb.png" alt="" />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* 礼物 */}
        <div className="gifts">
          <div className="gifts-bg" style={{ marginTop: gold.length > 0 ? '6.1rem' : '0rem' }}>
            <div className="title">{lang.eventgifts}</div>
            <div className="list">
              {/* gift-list */}
              {gifts &&
                gifts.length > 0 &&
                gifts.map((item) => {
                  return (
                    <div className="gift-list" key={item.giftid}>
                      <img className="user" src={item.image} alt="" />
                      <div className="money">
                        <img src="/img/activity/national/jb.png" alt="" />
                        <span>{item.gold}</span>
                      </div>
                    </div>
                  )
                })}
            </div>
            <div className="desc">
              <div>{lang.points}</div>
            </div>
          </div>
        </div>

        {/* 倒计时 */}
        <div className="time">
          {/*  倒计时 */}
          <Countdown language={language} lang={this.state.lang} remaintime={remaintime} now={now} />
        </div>

        {/* 选择tab切换 */}
        <div className="select-part">
          <div
            className={this.state.selectState === '0' ? 's-active' : 's1'}
            onClick={() => this.changeSelectState('0')}
          >
            {lang.nationalTresures}
          </div>
          <div className={this.state.selectState === '1' ? 's-active' : 's2'} onClick={() => this.changeTwo()}>
            {lang.rankings}
          </div>
          <div
            className={this.state.selectState === '2' ? 's-active' : 's3'}
            onClick={() => this.changeSelectState('2')}
          >
            {lang.rewards}
          </div>
        </div>
        <div className="select-other" style={{ display: this.state.selectState === '1' ? 'flex' : 'none' }}>
          <div
            className={this.state.selectStateChild === '2' ? 'active' : 'last-week-btn'}
            onClick={() => this.changeSelectStateChild('2')}
          >
            {lang.LastWeek}
          </div>
          <div
            className={this.state.selectStateChild === '1' ? 'active' : 'this-week-btn'}
            onClick={() => this.changeSelectStateChild('1')}
          >
            {lang.ThisWeek}
          </div>
        </div>

        {/* 宝藏 */}
        <Treasures
          selectState={this.state.selectState}
          gemstoneValue={gemstone.value}
          thisNationalRank={thisGoldRank}
          lastUserRankList={lastUserRank}
          myRankList={myRank}
          lang={this.state.lang}
          language={this.state.language}
        />

        {/* 排名 */}
        <Rank
          selectState={this.state.selectState}
          userRankList={rank}
          selectStateChild={this.state.selectStateChild}
          lastUserRankList={lastUserRank}
          mycuntry={userInfo}
          lang={this.state.lang}
          thisMyUserRank={thisMyUserRank}
          lastMyUserRank={lastMyUserRank}
          language={this.state.language}
        />

        {/* 奖励 */}
        <Reward
          selectState={this.state.selectState}
          lang={this.state.lang}
          language={this.state.language}
          rewardList={this.state.rewardList}
        />

        {/* 弹窗 */}
        <Reminder show={this.state.show} changeShow={() => this.changeShow('none')} lang={this.state.lang} />

        {/* 有效国家 */}
        <Available
          availShow={this.state.availShow}
          changeAvail={() => this.changeAvail('-200vh')}
          userInfo={userInfo}
          lang={this.state.lang}
        />

        {/* 客服 */}
        {this.serviceComp()}

        {/* 版权 */}
        {this.copyrightComp()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national/index.js